import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import useContextActions from '../../../../hooks/useContextActions';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useSociete, useTiersService } from '@europrocurement/l2d-domain';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { parcoursFormalitePathResolver } from '@europrocurement/l2d-modules';

import { ContextActionType, useDumbActionsContext } from '@europrocurement/flexy-components';
import { useAppDispatch } from '../../../../redux/types';

import { PRESCRIBER_NEW } from '../../constants/paths';

export const PrescripteursListingActions: React.FunctionComponent<{ itemId: number | string }> =
    function ({ itemId }) {
        const navigate = useNavigate();

        const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const { selectPrescripteur } = useTiersService();
        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const contextActions: ContextActionType[] = [
            {
                name: 'Ajouter prescripteur',
                icon: <PersonAddIcon />,
                action: () => navigate(PRESCRIBER_NEW),
            },
        ];

        useDumbActionsContext(contextActions);

        const xIdSociete = useSociete();

        const dispatch = useAppDispatch();

        const createFormaliteFolder = React.useCallback(async () => {
            if (xIdSociete !== 12) {
                enqueueSnackbar(
                    'Impossible de saisir un dossier de formalite hors de Legal2Digital',
                );
                handleClose();
                return;
            }
            await dispatch(selectPrescripteur({ id: +itemId }));
            navigate(parcoursFormalitePathResolver('stepContact'));
        }, [dispatch, itemId, navigate, selectPrescripteur, xIdSociete]);

        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleClose}>
                        <Link
                            to={`${itemId}`}
                            target="_blank"
                            style={{ textDecoration: 'none' }}
                        >
                            <Typography sx={{ color: 'text.primary' }}>
                                Ouvrir dans un nouvel onglet
                            </Typography>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>Consulter factures</MenuItem>
                    <MenuItem onClick={createFormaliteFolder}>
                        Saisir un dossier de formalite
                    </MenuItem>
                </Menu>
            </div>
        );
    };
